import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center py-6 md:justify-start md:space-x-10" }
const _hoisted_2 = { class: "flex justify-start lg:w-0 lg:flex-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Brand Logo", -1)
const _hoisted_4 = { class: "-mr-2 -my-2 md:hidden" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Open menu", -1)
const _hoisted_6 = { class: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden" }
const _hoisted_7 = { class: "relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8" }
const _hoisted_8 = { class: "text-base font-medium text-gray-900" }
const _hoisted_9 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_10 = { class: "hidden md:flex items-center justify-end md:flex-1 lg:w-0" }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", { class: "transition duration-250 text-brand-button-text bg-brand-button hover:bg-brand-button-hover block py-3 px-6 border border-transparent rounded-md text-center font-medium text-brand-secondary" }, " Login ", -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50" }
const _hoisted_15 = { class: "pt-5 pb-6 px-5" }
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = { class: "-mr-2" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close menu", -1)
const _hoisted_19 = { class: "py-6 px-5" }
const _hoisted_20 = { class: "grid grid-cols-1 gap-4" }
const _hoisted_21 = { class: "mt-6" }
const _hoisted_22 = ["href"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("button", { class: "w-full flex items-center justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-brand-button-text bg-brand-button hover:bg-brand-button-hover transition duration-250" }, " Login ", -1)
const _hoisted_24 = [
  _hoisted_23
]

import { Popover, PopoverButton, PopoverGroup, PopoverPanel } from '@headlessui/vue';
import {
  MenuIcon, XIcon,
  ChevronDownIcon,
  LoginIcon
} from '@heroicons/vue/outline';
import { RenderFunction } from 'vue';
import Logo from '../content/Logo.vue';

type Feature = {
  name: string,
  href: string,
  description: string,
  icon: RenderFunction
}

type MainLink = {
  name: string,
  href: string,
  features?: Array<Feature>
}


export default /*#__PURE__*/_defineComponent({
  props: {
    links: { type: Array, required: true },
    portal: { type: String, required: true }
  },
  emits: ["ctaClicked"],
  setup(__props: any, { emit }: { emit: ({(e: 'ctaClicked'): void}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(Popover), { class: "relative bg-white" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(Logo)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(PopoverButton), { class: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_unref(MenuIcon), {
                class: "h-6 w-6",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_unref(PopoverGroup), {
          as: "nav",
          class: "hidden md:flex space-x-10"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link) => {
              return (_openBlock(), _createElementBlock("div", {
                key: link.name
              }, [
                (!link.features)
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: link.href,
                      class: "transition duration-250 text-base font-medium text-gray-500 hover:text-gray-900"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(link.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createBlock(_unref(Popover), {
                      key: 1,
                      class: "relative"
                    }, {
                      default: _withCtx(({ open }) => [
                        _createVNode(_unref(PopoverButton), {
                          class: _normalizeClass([open ? 'text-gray-900' : 'text-gray-500', 'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500'])
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, _toDisplayString(link.name), 1),
                            _createVNode(_unref(ChevronDownIcon), {
                              class: _normalizeClass([open ? 'text-gray-600' : 'text-gray-400', 'ml-2 h-5 w-5 group-hover:text-gray-500']),
                              "aria-hidden": "true"
                            }, null, 8, ["class"])
                          ]),
                          _: 2
                        }, 1032, ["class"]),
                        _createVNode(_Transition, {
                          "enter-active-class": "transition ease-out duration-200",
                          "enter-from-class": "opacity-0 translate-y-1",
                          "enter-to-class": "opacity-100 translate-y-0",
                          "leave-active-class": "transition ease-in duration-150",
                          "leave-from-class": "opacity-100 translate-y-0",
                          "leave-to-class": "opacity-0 translate-y-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(PopoverPanel), { class: "absolute z-10 left-1/2 transform -translate-x-1/2 mt-3 px-2 w-screen max-w-xs sm:px-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createElementVNode("div", _hoisted_7, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.features, (feature) => {
                                      return (_openBlock(), _createBlock(_component_router_link, {
                                        key: feature.name,
                                        href: feature.href,
                                        class: "-m-3 p-3 block rounded-md hover:bg-gray-50"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("p", _hoisted_8, _toDisplayString(feature.name), 1),
                                          _createElementVNode("p", _hoisted_9, _toDisplayString(feature.description), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["href"]))
                                    }), 128))
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
              ]))
            }), 128))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("a", { href: __props.portal }, _hoisted_13, 8, _hoisted_11)
        ])
      ]),
      _createVNode(_Transition, {
        "enter-active-class": "duration-250 ease-out",
        "enter-from-class": "opacity-0 scale-95",
        "enter-to-class": "opacity-100 scale-100",
        "leave-active-class": "duration-100 ease-in",
        "leave-from-class": "opacity-100 scale-100",
        "leave-to-class": "opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(PopoverPanel), {
            focus: "",
            class: "absolute top-0 -inset-x-6 p-2 transition transform origin-top-right md:hidden"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", null, [
                      _createVNode(Logo)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_unref(PopoverButton), { class: "bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500" }, {
                        default: _withCtx(() => [
                          _hoisted_18,
                          _createVNode(_unref(XIcon), {
                            class: "h-6 w-6",
                            "aria-hidden": "true"
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.links, (link) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: link.name
                      }, [
                        _createVNode(_component_router_link, {
                          to: link.href,
                          class: "text-base font-medium text-gray-900 hover:text-gray-700"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(link.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("a", { href: __props.portal }, _hoisted_24, 8, _hoisted_22)
                  ])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})